import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": "1.5",
  d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M8.148 15H7.051v-4.137a3.8 3.8 0 0 1-1.418.832V10.7q.429-.14.933-.531.504-.395.692-.918h.89zm5.592-1.02V15H9.892q.063-.578.375-1.094.313-.519 1.235-1.375.741-.69.91-.937.226-.34.226-.672 0-.367-.199-.563-.195-.199-.543-.199-.343 0-.547.207-.203.207-.234.688l-1.094-.11q.098-.906.613-1.3.516-.395 1.29-.395.848 0 1.332.457a1.5 1.5 0 0 1 .484 1.137q0 .387-.14.738a3 3 0 0 1-.438.73q-.2.255-.719.731-.519.477-.66.633a2 2 0 0 0-.223.304zm.947-.5 1.063-.128q.05.405.273.62a.75.75 0 0 0 .539.216.73.73 0 0 0 .57-.258q.235-.258.235-.696 0-.413-.223-.656a.71.71 0 0 0-.543-.242q-.21 0-.504.082l.121-.895q.446.012.68-.191a.7.7 0 0 0 .234-.547.62.62 0 0 0-.172-.46.62.62 0 0 0-.457-.173.66.66 0 0 0-.48.196q-.2.195-.242.57l-1.012-.172q.106-.519.316-.828.216-.312.594-.488.382-.18.856-.18.808 0 1.297.516.402.421.402.953 0 .753-.824 1.203.492.105.785.473.297.366.297.886 0 .754-.551 1.285-.55.532-1.371.532-.777 0-1.29-.446-.51-.45-.593-1.171"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }